module.exports = "<app-section-opening-page\n[loading]=\"loading\"\n[pageData]=\"pageData\"\n[hierarchy]=\"'What we do'\"></app-section-opening-page>\n"